import * as React from "react";
import { useParams } from "react-router-dom";
import { HangarStateContainer } from "../../containers/HangarStateContainer";
import { TowingEquipmentContainer } from "../../containers/TowingEquipmentContainer";
import { ParamSet } from "../../types";
import { HangarPresenter } from "../Hangar/HangarPresenter";
import { StackMember } from "../Hangar/PlaceIncrementally";

export type HangarStack = {
  paramSet: ParamSet;
  stackMembers: StackMember[];
};

type Props = {
  hangarId?: string;
  isReference?: boolean;
};

export const HangarAlgorithmDev: React.FC<Props> = ({
  hangarId,
  isReference,
}) => {
  const { id: hangarIdFromRoute } = useParams();
  const [stacks, setStacks] = React.useState<HangarStack[]>([]);

  return (
    <HangarStateContainer
      initialState={{
        hangar_id: hangarId ?? hangarIdFromRoute,
        isReference: isReference ?? false,
      }}
    >
      <TowingEquipmentContainer>
        <HangarPresenter
          id={hangarId ?? hangarIdFromRoute}
          isAlgorithmTesting={true}
          stacks={stacks}
          setStacks={setStacks}
          isReference={isReference}
        />
      </TowingEquipmentContainer>
    </HangarStateContainer>
  );
};
